import { MutationTree } from "vuex";
import { UserState } from "./types";
import User from "../../models/User";

export const mutations: MutationTree<UserState> = {
  setUser(state: UserState, user: User | null): void {
    state.user = user;
  }
};
